<!--
 * @Author: guoyu
 * @Date: 2021-04-20 11:53:14
 * @LastEditors: your name
 * @LastEditTime: 2021-04-22 18:23:02
 * @Description: 邀請信息與提領解釋
-->
<template>
  <div>
    <div class="invite-info">
      <div class="info-item">
        <span class="info-val">{{ inviteInfo.invitedUserNum || 0 }}</span>
        <span class="info-unit">人</span>
        <div class="info-name">已邀請用戶</div>
      </div>

      <div class="info-item">
        <span class="info-val">{{ inviteInfo.payedUserNum || 0 }}</span>
        <span class="info-unit">人</span>
        <div class="info-name">已消費用戶</div>
      </div>

      <div class="info-item">
        <span class="info-val">{{ inviteInfo.profit || 0 }}</span>
        <span class="info-unit">幣</span>
        <div class="info-name">
          已獲得獎勵
        </div>
        <el-popover
          v-model="popupShow"
          :show-close="false"
        >
          <h2 class="popup-title">您已獲得獎勵金</h2>
          <!-- <div class="award-info">
            <i class="coin-icon"></i>
            <span class="popup-amount">{{ inviteInfo.profit || 0 }}</span>
            <span>幣</span>
          </div> -->
          <p class="explain-title explain-invite">提領說明：</p>
          <p class="explain-invite">
            1.獎勵金會合并計入可提領收入中，並遵循提領規則
          </p>
          <p class="explain-invite">2.請在網頁端陪玩師管理中心-收入申請提領</p>
          <p class="explain-invite">
            3.額外bonus會在每個自然月月底進行結算，金額以合約為準
          </p>
          <p class="explain-invite">
            4.此數據嚴格按照後台顯示的用戶消費紀錄所呈現
          </p>
          <br />
          <p class="explain-invite">**此活動最終解釋權歸nicee官方所有**</p>
          <div class="how-getaward" slot="reference">
            如何提領？
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    inviteInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      popupShow: false
    };
  }
};
</script>
<style lang="scss" scoped>
.invite-info {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.info-item {
  font-size: 12px;
  color: #44072e;
}
.info-val {
  font-size: 28px;
  line-height: 32px;
}
.info-name {
  margin-top: 4px;
}
.how-getaward {
  margin-top: 6px;
  text-decoration-line: underline;
  color: #e75706;
  cursor: pointer;
}
.popup-title {
  margin-bottom: 11px;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #44072e;
}
.award-info {
  font-size: 12px;
  color: #44072e;
}
.coin-icon {
  display: inline-block;
  height: 26px;
  width: 26px;
  margin-right: 4px;
  vertical-align: top;
  background: url(~@/assets/image/icons/coin.png) no-repeat;
  background-size: 100% 100%;
}
.popup-amount {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
.extral-award {
  margin-left: 8px;
}
.explain-title {
  margin-top: 24px;
}
.explain-invite {
  font-size: 12px;
  line-height: 24px;
  color: #44072e;
}
</style>
